import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const generateOtpForRegister = async (email) => {
  try {
    const response = await axios.post(`${apiUrl}/api/generate-otp/`, {
      email: email,
      action: "C",
    });

    return response;
  } catch (error) {
    console.error("Error generating OTP:", error.message);
    throw error;
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${apiUrl}/api/verify-otp/`, {
      email: email,
      otp: otp,
      action: "C",
    });

    return response;
  } catch (error) {
    console.error("OTP verification error:", error.message);
    throw error;
  }
};

export const setPassword = async (email, password, confirmPassword) => {
  try {
    const response = await axios.post(`${apiUrl}/api/set-password/`, {
      email: email,
      password: password,
      confirm_password: confirmPassword,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Something went wrong. Please try again.",
      status: error.response?.status,
    };
  }
};
export const setUserPassword = async (email, password, confirmPassword) => {
  const response = await axios.post(
    `${apiUrl}/api/set-company-user-password/`,
    {
      email: email,
      password: password,
      confirm_password: confirmPassword,
    },
  );

  return response;
};
